angular.module('app.error')
    .run(['$transitions', '$state', 'AccountManager', '$log', function($transitions, $state, AccountManager, $log) {
        $state.defaultErrorHandler(function(error) {
            var type;

            // @see https://github.com/ui-router/core/blob/24da33201e55361e6e040b73306dd878e6f06b31/src/transition/rejectFactory.ts#L10
            switch (error.type) {
                case 2:
                    type = 'SUPERSEDED';
                    break;
                case 3:
                    type = 'ABORTED';
                    break;
                case 4:
                    type = 'INVALID';
                    break;
                case 5:
                    type = 'IGNORED';
                    break;
                case 6:
                    type = 'ERROR';
                    break;
            }

            $log.info('Transaction ' + type, error);
        });

        $transitions.onError({}, function(transition) {
            if (transition.error().type === 6) { // ERROR
                var error = transition.error().detail;

                var errorCode = error.code || error.message;
                var errorType = error.type || 'Error';

                switch (errorCode) {
                    case 'authentication-required':
                        $state.go('login', {
                            warn: 'authentication-required',
                            redirect: transition.targetState().name(),
                            params: transition.targetState().params(),
                        });
                        break;

                    case 'permission-required':
                        if (AccountManager.isLogged()) {
                            $state.go('error', {
                                code: 'permission-required',
                            });
                        } else {
                            $state.go('login', {
                                warn: 'authentication-required',
                                redirect: transition.targetState().name(),
                                params: transition.targetState().params(),
                            });
                        }
                        break;

                    default:
                        $state.go('error', {
                            type: errorType,
                            code: errorCode,
                        });
                }
            }
        });
    }]);
